import styled from "styled-components";
import { pxToRem } from "../../styles/utils";

export const SubscriptionContainer = styled.div`
  display: flex;
  height: calc(100% - ${pxToRem(24)});
  margin: ${pxToRem(12)};
`;

export const ContentWrapper = styled.div`
  flex: 1;
  margin-left: 0;
  background: white;
  border-radius: ${pxToRem(16)};
  box-shadow: 0px ${pxToRem(9)} ${pxToRem(14.5)} rgba(0, 0, 0, 0.06),
    0px 0px ${pxToRem(6)} rgba(31, 10, 53, 0.05);
  padding: ${pxToRem(32)} ${pxToRem(25)};
  box-sizing: border-box;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${pxToRem(32)};
`;

export const Title = styled.h1`
  font-size: ${pxToRem(24)};
  font-weight: 700;
  color: rgb(31, 10, 53);
`;

export const ButtonWrapper = styled.div``;

export const BaseButton = styled.div`
  font-size: ${pxToRem(18)};
  font-weight: 700;
  background: none;
  border: none;
  cursor: pointer;
  transition: all 0.5s ease;

  &:hover {
    transform: translateY(-${pxToRem(1)});
  }
`;

export const ChargeTariffButton = styled(BaseButton)`
  color: rgb(114, 82, 220);
`;

export const CancelSubscriptionButton = styled(BaseButton)`
  color: rgb(242, 40, 98);
`;

export const AutoRenewalSubscriptionButton = styled(BaseButton)`
  display: flex;
  justify-content: end;
  gap: ${pxToRem(20)};
  color: rgb(143, 132, 154);
  font-weight: 500;
`;

export const SubscriptionDetails = styled.div`
  box-sizing: border-box;
  border: ${pxToRem(1)} solid rgba(31, 10, 53, 0.1);
  border-radius: ${pxToRem(16)};
  box-shadow: 0px 0px 0px ${pxToRem(6)} rgba(31, 10, 53, 0.05);
  margin: ${pxToRem(40)} 0;
  padding-top: ${pxToRem(20)};
  padding-bottom: ${pxToRem(20)};
  padding-left: ${pxToRem(34)};
  padding-right: ${pxToRem(34)};
`;

export const SubscriptionLabel = styled.div`
  font-size: ${pxToRem(18)};
  color: rgb(31, 10, 53);
  font-weight: 600;
  grid-column: 1;
`;

export const SubscriptionValue = styled.div`
  font-size: ${pxToRem(18)};
  color: rgb(31, 10, 53);
  font-weight: 500;
  grid-column: 2;
`;

export const SubscriptionAction = styled.div`
  grid-column: 3;
  text-align: right;
`;

export const SubscriptionRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 3fr;
  margin-bottom: ${pxToRem(16)};
  border-bottom: ${pxToRem(1)} solid #e4e4e4;
  padding-bottom: ${pxToRem(20)};
`;

export const ActionsContainer = styled.div`
  display: flex;
  gap: ${pxToRem(16)};
  justify-content: flex-start;
`;

export const EditIcon = styled.img`
  width: ${pxToRem(16)};
  height: ${pxToRem(16)};
  cursor: pointer;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
